import { cva } from "class-variance-authority";

export { default as Switch } from "./Switch";
export { default as OptIn } from "./OptIn";
export const sizes = ["sm", "md"];

export const optInVariants = cva(
    ["flex", "border", "rounded-md", "cursor-pointer"],
    {
        variants: {
            checked: {
                false: ["border-secondary"],
            },
            type: {
                switch: ["gap-4", "p-4"],
            },
        },
        compoundVariants: [
            {
                checked: [true],
                highlightChecked: [true],
                class: ["border-brand", "bg-brand-primary_alt"],
            },
            {
                type: "checkbox",
                size: "sm",
                class: ["gap-2", "py-3", "pl-3", "pr-5"],
            },
            {
                type: "checkbox",
                size: "md",
                class: ["gap-3", "py-4", "px-5"],
            },
        ],
    }
);

export const optInLabelVariants = cva(
    ["text-ellipsis", "pointer-events-none"],
    {
        variants: {
            type: {
                switch: [
                    "!text-primary",
                    "!text-style-base",
                    "!font-semibold",
                    "!mb-0",
                ],
                checkbox: ["text-secondary", "font-medium"],
            },
        },
        compoundVariants: [
            {
                type: "checkbox",
                size: "sm",
                class: ["!text-style-base"],
            },
            {
                type: "checkbox",
                size: "md",
                class: ["!text-style-lg"],
            },
        ],
    }
);

export const optInHintVariants = cva(
    ["text-style-sm", "font-normal", "text-ellipsis", "!mt-0"],
    {
        variants: {
            checked: {
                true: ["text-tertiary"],
                false: ["text-quaternary"],
            },
        },
    }
);

export const rootVariants = cva(
    [
        "focus-within:ring-brand",
        "shadow-sm",
        "rounded-full",
        "relative",
        "bg-tertiary",
        "transition-transform",
        "cursor-default",
        "disabled:bg-disabled",
    ],
    {
        variants: {
            size: {
                sm: ["w-9", "h-5"],
                md: ["w-11", "h-6"],
            },
        },
        compoundVariants: [
            {
                checked: [true],
                disabled: [false],
                class: ["hover:button-primary-bg_hover", "button-primary-bg"],
            },
            {
                checked: [true],
                disabled: [true],
                class: ["bg-disabled"],
            },
        ],
        defaultVariants: {
            size: "md",
            indeterminate: false,
            disabled: false,
            checked: false,
        },
    }
);

export const thumbVariants = cva(
    [
        "items-center",
        "justify-center ",
        "block",
        "my-auto",
        "shadow-sm ",
        "rounded-full ",
        "transition-transform",
        "duration-100 ",
        "will-change-transform",
        "ease-in-out",
    ],
    {
        variants: {
            size: {
                sm: ["w-4", "h-4"],
                md: ["w-5", "h-5"],
            },
            disabled: {
                true: ["toggle-button-fg_disabled"],
                false: ["bg-white"],
            },
        },
        compoundVariants: [
            {
                size: "sm",
                checked: [true],
                class: ["ltr:translate-x-[18px]", "rtl:translate-x-[-18px]"],
            },
            {
                size: "md",
                checked: [true],
                class: ["ltr:translate-x-[21px]", "rtl:translate-x-[-21px]"],
            },
            {
                size: "sm",
                checked: [false],
                class: ["ltr:translate-x-0.5", "rtl:-translate-x-0.5"],
            },
            {
                size: "md",
                checked: [false],
                class: ["ltr:translate-x-[3px]", "rtl:translate-x-[-3px]"],
            },
        ],
    }
);
